export { default as SchemaEvent } from "./schemaEvent";
export { default as SchemaReview } from "./schemaReview";



// WEBPACK FOOTER //
// ./assets/pois/components/schema/index.jsx